import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import PrintButton from "./PrintButton";
import ReportSection from "./ReportSection";
import ProjectInformationReport from "./ProjectInformationReport";
import GlobalInputReport from "./GlobalInputReport";
import {
  LIFE_CYCLE_COST_STEPPER_STEPS_ORDER,
  LIFE_CYCLE_COST_STEPS_ORDER,
  STEPS,
} from "../constants/stepsConstants";
import {
  PENN_DOT_BLUE,
  PENN_DOT_GREEN_DARK,
} from "../constants/styleConstants";

import "./printView.css";
import { getEvaluationType } from "../util/dataSelectors";

function getTitle(steps) {
  return LIFE_CYCLE_COST_STEPPER_STEPS_ORDER[
    LIFE_CYCLE_COST_STEPS_ORDER.indexOf(steps) - 1
  ].label;
}
/**
 * @param {node} children
 * @param {function} onClose
 * @param {object} projectData
 * @param {node} title
 */
export default function PrintableReport({
  children,
  onClose,
  projectData,
  title,
}) {
  const dateTime = new Date();
  const dateAndTime = (
    <Typography>
      {dateTime.toLocaleDateString()} -{" "}
      {dateTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
      })}
    </Typography>
  );
  return (
    <div
      className="printViewOverflowVisible"
      style={{ overflowY: "auto", padding: "20px 20px 0 20px" }}
    >
      <PrintButton onClose={onClose} />
      <div style={{ maxWidth: "1025px" }}>
        <div style={{ marginBottom: "40px", textAlign: "center" }}>
          <Typography sx={{ fontWeight: "700" }} variant="h4">
            {title}
          </Typography>
          {dateAndTime}
        </div>
        <ReportSection
          borderColor={PENN_DOT_BLUE}
          title={getTitle(STEPS.PROJECT_INFORMATION)}
        >
          <ProjectInformationReport projectData={projectData} />
          <div style={{ margin: "15px 0" }}></div>
          {getEvaluationType(projectData) !== "CAP_X" ? (
            <GlobalInputReport projectData={projectData} />
          ) : null}
        </ReportSection>
        {children}
        <>
          <div
            style={{
              borderBottom: `4px ${PENN_DOT_GREEN_DARK} solid`,
              height: "2px",
              width: "100%",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Typography sx={{ fontWeight: "700" }} variant="h5">
              {title}
            </Typography>
            {dateAndTime}
          </div>
        </>
      </div>
      <PrintButton onClose={onClose} />
    </div>
  );
}

PrintableReport.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  projectData: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
};
